import React, { useEffect, useRef, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { pretestApi } from '../../shared/pretests/pretestApi';
import { PretestError, PretestLoading } from '../../shared/pretests/PretestUI';
import { pretestError } from '../../shared/pretests/pretestModel';
import './ExampleView.css';
export default function ExampleView() {
  const [params] = useSearchParams(); const courseId = params.get('courseId');
  return <div className="container py-4 pretest-page"><h1 className="h3">แบบทดสอบ Pre-Test</h1><p>ประเมินความรู้ก่อนสมัครเรียน พร้อมตรวจคะแนนและดูเฉลย</p>
    <PublicTests key={courseId === null ? 'all' : `course:${courseId}`} courseId={courseId}/></div>;
}
function PublicTests({ courseId }) {
  const courses = useRef(new Map());
  const [groups, setGroups] = useState([]); const [loading, setLoading] = useState(true);
  const [error, setError] = useState(''); const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true; setLoading(true); setError(''); setGroups([]);
    async function load() {
      if (courseId !== null && (!courseId.trim() || courseId.includes('/') || ['.', '..'].includes(courseId))) throw new Error('รหัสคอร์สไม่ถูกต้อง');
      // Read every page so one course's tests are never split across separate views.
      const tests = new Map(); let cursor = null;
      do {
        const page = await pretestApi.list({ courseId: courseId ?? '', cursor });
        if (!active) return;
        page.items.forEach(test => {
          if (test.isActive === true && (courseId === null || test.courseId === courseId)) tests.set(test.id, test);
        });
        cursor = page.next;
      } while (cursor);
      const byCourse = new Map();
      tests.forEach(test => {
        if (!byCourse.has(test.courseId)) byCourse.set(test.courseId, []);
        byCourse.get(test.courseId).push(test);
      });
      const compare = (a, b) => a.title.localeCompare(b.title, 'th') || a.id.localeCompare(b.id);
      const entries = await Promise.all([...byCourse].map(async ([id, items]) => {
        // Cache successful/in-flight reads for this view; failed reads can be retried.
        if (!courses.current.has(id)) courses.current.set(id, pretestApi.course(id).then(course => {
          if (!course || typeof course.title !== 'string' || !course.title.trim()) throw new Error('ไม่พบข้อมูลชื่อคอร์สที่เชื่อมโยงกับแบบทดสอบ กรุณาลองอีกครั้ง');
          return course;
        }).catch(failure => { courses.current.delete(id); throw failure; }));
        const course = await courses.current.get(id);
        return { id, title: course.title, items: items.sort((a, b) => compare({ id: a.id, title: a.content.title }, { id: b.id, title: b.content.title })) };
      }));
      if (active) setGroups(entries.sort(compare));
    }
    load().catch(failure => { if (active) setError(pretestError(failure)); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [courseId, attempt]);
  return <>{loading && <PretestLoading/>}<PretestError error={error} retry={() => setAttempt(value => value + 1)} busy={loading}/>
    {!loading && !error && !groups.length && <p>ยังไม่มีแบบทดสอบที่เปิดใช้งานในรายการนี้</p>}
    {groups.map((group, index) => <section key={group.id} data-course-id={group.id} aria-labelledby={`pretest-course-group-${index}`} className="mb-4">
      <h2 id={`pretest-course-group-${index}`} className="h4 border-bottom pb-2 mb-3">{group.title}</h2>
      {group.items.map(test => <Card className="mb-3 pretest-public-test-card" key={test.id}><Card.Body><h3 className="h5">{test.content.title}</h3><p className="pretest-text">{test.content.description}</p><p>{test.content.questions.length} ข้อ · ข้อละ 1 คะแนน</p><Button as={Link} to={`/pre-tests/${test.id}`}>เริ่มแบบทดสอบ</Button></Card.Body></Card>)}
    </section>)}</>;
}
